import { useEffect, useContext } from 'react';
import CompanyReport from 'kosmos/components/companyReport';
import { tfpDefaultMenuList, reportSectionMenus } from 'kosmos/TfpApp';
import MenuConfigContext from 'data/MenuConfigContext';

interface IProps {
  id: string;
  organisationId?: string;
  onBack?: () => void;
}

export default function CompanyReportWithMenus(props: IProps): JSX.Element {
  const { id, organisationId, onBack } = props;
  const context = useContext(MenuConfigContext);

  useEffect(() => {
    const { setMenuItems } = context;
    setMenuItems && setMenuItems(reportSectionMenus);
    return () => {
      // unmount, clear menu
      setMenuItems && setMenuItems(tfpDefaultMenuList());
    };
  }, []);

  return (
    <CompanyReport id={id} organisationId={organisationId} onBack={onBack} />
  );
}

